import {createTextVariant} from './Text.js'

export default createTextVariant('h5', 'H5')
